import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Reset Styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Root Variables */
  :root {
    --primary-color: #8BC34A; /* Bright Green */
    --secondary-color: #689F38; /* Darker Green */
    --background-color: #F4F4F9; /* Light Gray */
    --text-color: #333333; /* Dark Gray */
    --highlight-color: #FFFFFF; /* White */
    --error-color: #FF5252; /* Red for errors */
  }

  /* Global Styles */
  html, body {
    font-family: 'Roboto', Arial, sans-serif; /* Changed from 'Poppins' to 'Roboto' */
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  /* Links */
  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: color 0.3s ease;

    &:hover {
      color: var(--secondary-color);
    }
  }

  /* Buttons */
  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
    background-color: var(--primary-color);
    color: var(--highlight-color);
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: var(--secondary-color);
    }
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    color: var(--text-color);
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    body {
      font-size: 14px;
    }
  }
`;